//core
import React, {Dispatch, SetStateAction, useContext, useEffect, useState} from "react";
import { useTranslation } from "react-i18next";
import { useLocalStorage } from "usehooks-ts";
import {
  Box,
  useMediaQuery,
} from "@mui/material";

//styles
import { useStyles } from "./styles";

//constant
import { favoriteFilterKeys } from "../../../../constants";

//hooks
import { useSubAffDealsV2 } from "../../../../../../../store/admin/subAffDealsV2/useSubAffDealsV2";
import { useFields } from "../../../../../../../store/common/fields/useFields";

//context
import { GlobalContext } from "../../../../../../../context/GlobalContext";

//types
import { ISubAffDealsV2FilterDataType } from "../../../../types";

//components
import MuiAutocompleteSelectLazy from "../../../../../../UI/Fields/MuiAutocompleteSelectLazy";
import MuiAutocompleteSelect from "../../../../../../UI/Fields/MuiAutocompleteSelect";


interface IVisibleFilterProps {
  filter: ISubAffDealsV2FilterDataType;
  setUpdateFilter: Dispatch<SetStateAction<ISubAffDealsV2FilterDataType>>;
}

const VisibleFilter: React.FC<IVisibleFilterProps> = ({
  filter,
  setUpdateFilter,
}): JSX.Element => {
  const { t, i18n } = useTranslation();
  const styles = useStyles();
  const mobile = useMediaQuery('(max-width:767px)');

	const { getPlatforms } = useFields();
	const { getFilterCreator } = useSubAffDealsV2();

	const context = useContext(GlobalContext);

	const [platformsList, setPlatformsList] = useState<any | null>(null);

	//favorite fields state
	const [favAdmSADPlatformIds, setFavAdmSADPlatformIds] = useLocalStorage<boolean>(favoriteFilterKeys.platformIds, false);
	const [favAdmSADCreatedByIds, setFavAdmSADCreatedByIds] = useLocalStorage<boolean>(favoriteFilterKeys.createdByIds, false);

	useEffect(() => {
    context.setAdmSubAffDealsV2Filter(filter);
  }, [filter]);

	useEffect( () => {
		if (!platformsList) {
			(async () => {
				const data = await getPlatforms({});
				setPlatformsList(data.payload.list)
			})()
		}
	}, [platformsList]);

	const fieldPayload = () => {
		return {
			page: 1,
			search: null,
			per_page: 100,
		}
	};

  const favoriteFields = !mobile &&
  (favAdmSADPlatformIds || favAdmSADCreatedByIds)
    ? (
      <Box className={styles.favoriteFields}>
	      {favAdmSADPlatformIds && !!platformsList && platformsList.length > 1 && (
		      <Box>
			      <MuiAutocompleteSelectLazy
				      keyValue="value"
				      keyId="id"
				      id="platformIds"
				      name="platformIds"
				      label={t(`admin.reports.filter.platformIds`)}
				      value={filter.platformIds}
				      multiple={true}
				      showSelectAll={false}
				      disabled={false}
				      getOptions={getPlatforms}
				      payloadData={fieldPayload()}
				      labelWithId={false}
				      onChange={setUpdateFilter}
				      disableCloseOnSelect={true}
				      showLabelCounter={true}
				      maxHeightFieldScroll={55}
			      />
		      </Box>
	      )}
	      {favAdmSADCreatedByIds && (
		      <Box>
			      <MuiAutocompleteSelectLazy
				      keyValue="value"
				      keyId="id"
				      id="createdByIds"
				      name="createdByIds"
				      label={t(`admin.deals.filters.created_by`)}
				      value={filter.createdByIds}
				      multiple={true}
				      showSelectAll={false}
				      disabled={false}
				      getOptions={getFilterCreator}
				      payloadData={fieldPayload()}
				      labelWithId={false}
				      onChange={setUpdateFilter}
				      disableCloseOnSelect={true}
				      showLabelCounter={true}
				      maxHeightFieldScroll={55}
			      />
		      </Box>
	      )}

      </Box>
    ) : null;

  return (<>
	    {favoriteFields}
  </>);
};

export default VisibleFilter;
